import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Facesheet Forms
   */
  {
    label: 'Do you have any medical conditions?',
    field: 'conditions',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'isNone', value: 'No medical issues', uncheckOthers: true },
        {
          key: 'vascular',
          value: 'Stroke, blood clots or vascular disease',
          answer: {
            type: 'text',
            name: 'vascularDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'diabetes',
          value: 'Diabetes',
          answer: {
            type: 'radio',
            name: 'diabetesOption',
            label: 'Needing Insulin?',
            options: [
              { key: 'yes', value: 'Yes' },
              { key: 'no', value: 'No' }
            ]
          }
        },
        { key: 'hiv', value: 'HIV or AIDS' },
        { key: 'hypertension', value: 'High blood pressure' },
        { key: 'enlarged', value: 'Enlarged Prostate/BPH' },
        {
          key: 'heartCond',
          value: 'Heart disease',
          answer: {
            type: 'text',
            name: 'heartCondDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'irregular',
          value: 'Irregular heartbeat',
          answer: {
            type: 'text',
            name: 'irregularDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'thyroid',
          value: 'Thyroid condition',
          answer: {
            type: 'text',
            name: 'thyroidDesc',
            placeholder: 'Please describe'
          }
        },

        {
          key: 'cancer',
          value: 'Cancer',
          answer: {
            type: 'text',
            name: 'cancerDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'kidney',
          value: 'Kidney disease',
          answer: {
            type: 'text',
            name: 'kidneyDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'anxiety', value: 'Anxiety or Depression' },
        { key: 'asthma', value: 'Asthma or COPD' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherDesc',
            placeholder: 'Please describe'
          }
        }
      ]
    }
  },
  {
    label: 'Have you had any of the following surgeries?',
    field: 'surgeries',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'isNone', value: 'No past surgeries', uncheckOthers: true },
        {
          key: 'backNeck',
          value: 'Back or Neck Surgery',
          answer: {
            type: 'text',
            name: 'backNeckDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'heart',
          value: 'Heart surgery or stenting',
          answer: {
            type: 'text',
            name: 'heartDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'prostate',
          value: 'Prostate surgery',
          answer: {
            type: 'text',
            name: 'prostateDesc',
            placeholder: 'Please describe'
          }
        },
        {
          key: 'hysterectomy',
          value: 'Hysterectomy',
          answer: {
            type: 'text',
            name: 'hysterectomyDesc',
            placeholder: 'Please describe'
          }
        },
        { key: 'gallbladder', value: 'Gallbladder' },
        { key: 'weightloss', value: 'Weight loss surgery' },
        { key: 'appendix', value: 'Appendix' },
        { key: 'vasectomy', value: 'Vasectomy' },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherDesc',
            placeholder: 'Please describe'
          }
        }
      ]
    }
  },
  {
    label: 'Are you currently taking any medications?',
    field: 'medications',
    type: 'polar_check',
    answer: {
      type: 'list',
      items: [
        {
          label:
            'Please list any current medications you are taking (prescription or non-prescription), including dosage.',
          type: 'text_list',
          inputPlaceholder: 'Medication Name'
        }
      ]
    }
  },
  {
    label: 'Are you currently taking any supplements?',
    field: 'supplements',
    type: 'polar_check',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Please list any current supplements you are taking.',
          type: 'text_list',
          inputPlaceholder: 'Supplement name'
        }
      ]
    }
  },
  {
    label: 'Do you have any medical allergies?',
    field: 'allergies',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'penicillin', value: 'Penicillin/Amoxicillin' },
        { key: 'sulfa', value: 'Sulfa drugs' },
        { key: 'aspirin', value: 'Aspirin' },
        { key: 'codeine', value: 'Codeine' },
        { key: 'latex', value: 'Latex' },
        { key: 'isNone', value: 'None', uncheckOthers: true },
        {
          key: 'other',
          value: 'Other',
          answer: {
            type: 'text',
            name: 'otherDesc',
            placeholder: 'Please describe'
          }
        }
      ]
    }
  },
  {
    label: 'Upload a Government ID showing your date of birth.',
    field: 'govId',
    type: 'file_upload',
    questionImage: 'https://cdn.buttercms.com/pTC8iTmSdipV7CTZG9xV',
    answer: [
      {
        resourceId: 'govId',
        buttonLabel: 'Photo of ID'
      }
    ]
  },
  {
    label:
      'Take a Selfie of your face holding up your ID card.',
    field: 'selfie',
    type: 'file_upload',
    questionImage: 'https://cdn.buttercms.com/Qg4VfomnTNM4Iy7JzU2Y',
    answer: [
      {
        resourceId: 'selfie',
        buttonLabel: 'Take Selfie'
      }
    ]
  },
  {
    label:
      'Please upload a clear photo showing your full body.',
    field: 'bodySelfie',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'bodySelfie',
        buttonLabel: 'Body image'
      }
    ]
  },
  {
    label: 'Add your insurance for hassle free direct billing?',
    subLabel: 'Please upload the front and back sides of ALL your insurance cards',
    field: 'drugCard',
    type: 'image_list',
    answer: {
      label: 'Upload your drug plan card front and back sides (optional) ',
      option: {
        label: 'Drug plan card',
        buttonLabel: 'Card image',
        addLabel: '+Add another',
        resourceId: 'drugCard',
        limit: 4
      }
    }
  },
  {
    label: 'Risks of using Virtual Care Tools:',
    field: 'virtualCareTools',
    type: 'info',
    educationalSlide: `I acknowledge that I have read and fully understand the risks, limitations, conditions of use, and instructions for use of the selected Services more fully described in the Appendix to this consent form. I understand and accept the risks outlined in the Appendix to this consent form, associated with the use of the Services when interacting with the Physician, authorized non-physician provider and the Physician’s staff. I consent to the conditions and will follow the instructions outlined in the Appendix, as well as any other conditions that the Physician or authorized non-physician provider may impose in relation to patients using the Services.

    I acknowledge and understand that despite recommendations that encryption software be used as a security mechanism for virtual caretools, it is possible that interacting with the Physician, authorized non-physician provider or the Physician’s staff using the Services may not be encrypted. Despite this, I agree to interact with the Physician authorized non-physician provider, or the Physician’s staff using these Services with a full understanding of the risk.

    I acknowledge that either I or the Physician or the authorized non-physician provider  may, at any time, withdraw the option of using the Services upon providing written notice.
    
    `
    // The following link has the comprehensive description of Virtual Care Risks https://jackjill.health/virtual-care-risks/
    ,

    answer: {
      type: 'info',
      items: [
        {
          label:
            'By typing your FULL LEGAL name below, you are agreeing to the risks of using virtual care tools',
          type: 'text',
          placeholder: 'Type your legal full name',
          name: 'virtualCareRiskAgreement',
          rows: 1
        }
      ]
    }
  },

  // -----------------------
  // facesheet EXT
  // ---------------------------

  {
    label: 'Have you ever been told your kidneys are not working properly?',
    field: 'kidneysNotWorking',
    type: 'polar_check',
    answer: {
      label:
        'Please describe in as much detail as possible. If available, include most recent creatinine and/or eGFR level',
      name: 'kidneysNotWorkingDesc',
      type: 'text'
    }
  },
  {
    label: 'Have you ever been told your liver is not working properly?',
    field: 'liverNotWorking',
    type: 'polar_check',
    answer: {
      label:
        'Please describe in as much detail as possible. If available, include most recent ALT and AST levels',
      name: 'liverNotWorkingDesc',
      type: 'text'
    }
  },
  {
    label: 'Have you ever been told your heart is not pumping properly?',
    field: 'heartNotPumping',
    type: 'polar_check',
    answer: {
      label:
        'Please describe in as much detail as possible. If available, include the Ejection Fraction (EF) from your most recent echocardiogram and details on any other heart-related procedures or diagnoses',
      name: 'heartNotPumpingDesc',
      type: 'text'
    }
  },
  {
    label: 'Do you have a primary care provider?',
    field: 'havePrimaryProvider',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    label:
      'Have you had a general health check-up or routine physical in the past three years?',
    field: 'hadCheckoutIn3Years',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  }
];

export default questionsModels;
